import recommendedStores from './recommendedStores';

export default recommendedStores;
